import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-sw-mask',
  templateUrl: './sw-mask.component.html',
  styleUrls: ['./sw-mask.component.css']
})
export class SwMaskComponent implements OnInit {

  constructor() { }

  tip:string  //遮罩层的提示语
  ngOnInit() {
  }

  //打开遮罩层
  openMask() {
    $("#swMask").modal("show");
  }

  //关闭遮罩层
  closeMask() {
    $("#swMask").modal("hide");
  }
}
